/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ShieldChevron(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M207.99951,40.00012h-160a16.01818,16.01818,0,0,0-16,16v58.66651c0,89.45312,75.82617,119.12451,91.02637,124.16406a15.48361,15.48361,0,0,0,9.94726.00049c15.2002-5.04,91.02637-34.71143,91.02637-124.16455V56.00012A16.01817,16.01817,0,0,0,207.99951,40.00012Zm-160,16h160v58.66651c0,17.68237-3.39453,32.69653-8.79639,45.4104L132.5874,113.44617a8.00131,8.00131,0,0,0-9.17578,0L56.79541,160.077c-5.40137-12.71387-8.7959-27.728-8.7959-45.4104Z" />
    </Svg>
  );
}

export default ShieldChevron;
